import { render } from "./page-recomend.vue?vue&type=template&id=15d2ebd8&scoped=true"
import script from "./page-recomend.vue?vue&type=script&lang=js"
export * from "./page-recomend.vue?vue&type=script&lang=js"

import "./page-recomend.vue?vue&type=style&index=0&id=15d2ebd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d2ebd8"]])

export default __exports__